
import Swal from 'sweetalert2'
import {
  CREATE_ERROR,
  DELETE_ERROR,
} from './actionTypes/error'
import {
  HEADER_ERROR,
  TIMEOUT_ERROR,
  EXPIRED_ERROR,
  UNAUTHORIZED_ERROR,
  FORBIDDEN_ERROR,
  NOT_FOUND_ERROR,
  SERVER_ERROR,
  EXIST_ERROR,
  EXPIRED_SEASON_ERROR,
  EXPIRED_SEASON_HEADER_ERROR,
  INACTIVE_CENTER_HEADER_ERROR,
  INACTIVE_CENTER_ERROR,
  DEPENDENCY_ERROR,
} from './constants/messages'

import { configuration } from '../src/configuration'

export function createError(error) {
  if (error.status && error.status === 401) {

    return {
      type: CREATE_ERROR,
      payload: {
        hasAlert: true,
        message: error.data.message,
      },
    }
  }
  const message = error.data ? error.data.message : error

  return {
    type: CREATE_ERROR,
    payload: {
      hasAlert: true,
      message,
    },
  }
}

export function deleteError() {
  return {
    type: DELETE_ERROR,
    payload: { hasAlert: false },
  }
}

//* ERROR HANDLER

export function apiErrorHandler(error) {
  if (error.response) {
    // The request was made, but the server responded with a status code
    // that falls out of the range of 2xx
    // console.error(error.response)
    switch (error.response.status) {
      case 401:
        return generateSweetAlert(HEADER_ERROR, UNAUTHORIZED_ERROR)
      case 403:
        if (error.response.data === 'ExpiredSeason') {
          return generateSweetAlert(EXPIRED_SEASON_HEADER_ERROR, EXPIRED_SEASON_ERROR)
        } else if (error.response.data === 'InactiveCenter') {
          return generateSweetAlert(INACTIVE_CENTER_HEADER_ERROR, INACTIVE_CENTER_ERROR)
        }
        return generateSweetAlert(HEADER_ERROR, FORBIDDEN_ERROR)
      case 404:
        return generateSweetAlert(HEADER_ERROR, NOT_FOUND_ERROR)
      case 408:
        return generateSweetAlert(HEADER_ERROR, TIMEOUT_ERROR)
      case 409:
      case 424:
        let header_txt = HEADER_ERROR
        let description_txt = error.response.status === 424 ? DEPENDENCY_ERROR : EXIST_ERROR
        if (error.response.data) {
          if (error.response.data.msg_resume) {
            header_txt = error.response.data.msg_resume
          }
          if (error.response.data.msg_detail) {
            description_txt = error.response.data.msg_detail
          }
        }
        return generateSweetAlert(header_txt, description_txt)
      case 410:
        return generateSweetAlert(HEADER_ERROR, EXPIRED_ERROR)
      default:
        return generateSweetAlert(HEADER_ERROR, SERVER_ERROR)
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error(error)
    generateSweetAlert(HEADER_ERROR, SERVER_ERROR)
  }
}

function generateSweetAlert(title, text) {
  if (configuration().brandName && configuration().brandName.toLowerCase() === 'mazda') {
    return Swal.fire({
      title: title,
      text: text,
      confirmButtonClass: 'jump button-primary'
    })
  } else {
    return Swal.fire(title, text, 'error')
  }
}



// WEBPACK FOOTER //
// ./src/errors.js